import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CoachProfileController } from './coach-profile.controller';
import { CoachProfileStore } from './coach-profile.store';

@Component({
	selector: 'spr-coach-profile',
	templateUrl: './coach-profile.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [CoachProfileStore, CoachProfileController],
	host: {
		class: 'h-full',
	},
})
export class CoachProfileComponent {
	constructor(public controller: CoachProfileController) {}
}
